<template>
  <div>
    <div style="display: flex;" class="form-row">
      <h3 style="width: 80%;">Manage Accounting</h3>
      <div style="align-self: center; text-align: left;">
        <ejs-dropdownbutton :items='invoiceItems'  cssClass='e-info btn-ddl' iconCss='fas plus'
          :select="onAddInvoiceClick">Add New Invoice</ejs-dropdownbutton>
      </div>
    </div>
    <div class="e-card">
      <div id="OpenInvoicesTab" style="display: none">
        <accounting-open-invoices :isValidUser="isValidUser" />
      </div>
      <div id="ClosedInvoicesTab" style="display: none">
        <accounting-closed-invoices :isValidUser="isValidUser" />
      </div>
      <div id="HistoricalInvoicesTab" style="display: none">
        <accounting-historical-invoices :isValidUser="isValidUser" />
      </div>
      <div id="RefundsTab" style="display: none">
        <transaction-refunds :isValidUser="isValidUser" />
      </div>
      <div id="UserCreditsTab" style="display: none">
        <accounting-user-credits :isValidUser="isValidUser" />
      </div>

      <ejs-tab
        id="manageaccounting_tabs"
        class="e-background"
        ref="refManageAccountingTabs"
        :selecting="tabSelect"
        :selected="tabSelected"
      >
        <e-tabitems>
          <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
          <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
          <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
          <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
          <e-tabitem :header="headerText4" :content="content4"></e-tabitem>
        </e-tabitems>
      </ejs-tab>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { mapGetters } from 'vuex';
import AccountingOpenInvoices from '../components/accounting-open-invoices.vue';
import AccountingClosedInvoices from '../components/accounting-closed-invoices.vue';
import AccountingHistoricalInvoices from '../components/accounting-historical-invoices.vue';
import TransactionRefunds from '../components/transaction-refunds.vue';
import AccountingUserCredits from '../components/accounting-user-credits.vue';

import {
  FETCH_ACCOUNTING_CLOSED_INVOICES,
  FETCH_ACCOUNTING_HISTORICAL_INVOICES,
  FETCH_ACCOUNTING_OPEN_INVOICES,
  FETCH_ACCOUNTING_TRANSACTION_REFUNDS,
  FETCH_ACCOUNTING_USER_CREDITS,
} from '../store';

Vue.use(GridPlugin);
Vue.use(TabPlugin);
Vue.use(DropDownButtonPlugin);

export default {
  name: 'ManageAccountingHome',
  components: {
    AccountingOpenInvoices,
    AccountingClosedInvoices,
    AccountingHistoricalInvoices,
    TransactionRefunds,
    AccountingUserCredits,
  },
  data() {
    return {
      headerText0: { text: 'Open Invoices' },
      headerText1: { text: 'Closed Invoices' },
      headerText2: { text: 'Credits' },
      headerText3: { text: 'Refunds' },
      headerText4: { text: 'Historical Invoices' },
      content0: '#OpenInvoicesTab',
      content1: '#ClosedInvoicesTab',
      content2: '#UserCreditsTab',
      content3: '#RefundsTab',
      content4: '#HistoricalInvoicesTab',
      target: '#target',
      invoiceItems: [
        {
          id: 'AdditionalInvoice',
          text: 'Add New Permit Fee Invoice',
        },
        {
          id: 'MiscellaneousInvoice',
          text: 'Add New Miscellaneous Invoice',
        },
      ],
    };
  },
  mounted() {
    this.selectTabAndLoadData();
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
      previousAccountingTab: 'previousAccountingTab',
    }),
    isValidUser() {
      return (
        (this.isCurrentUserInRole('admin')
          || this.isCurrentUserInRole('superadmin')
          || this.isCurrentUserInRole('accounting'))
        && this.loggedUser != null
      );
    },
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  watch: {
    loggedUser() {
      this.selectTabAndLoadData();
    },
  },
  methods: {
    isCurrentUserInRole(roleName) {
      let roleIndex = -1;
      const LogedUser = this.loggedUser;
      if (LogedUser && LogedUser.roles) {
        roleIndex = LogedUser.roles.findIndex(
          (r) => r.roleName.toLowerCase() === roleName,
        );
      }
      return roleIndex >= 0;
    },
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    async tabSelected(e) {
      const tagId = e.selectedIndex;
      if (tagId === 0) {
        await this.$store.dispatch(FETCH_ACCOUNTING_OPEN_INVOICES);
      } else if (tagId === 1) {
        await this.$store.dispatch(FETCH_ACCOUNTING_CLOSED_INVOICES);
      } else if (tagId === 2) {
        await this.$store.dispatch(FETCH_ACCOUNTING_USER_CREDITS);
      } else if (tagId === 3) {
        await this.$store.dispatch(FETCH_ACCOUNTING_TRANSACTION_REFUNDS);
      } else if (tagId === 4) {
        await this.$store.dispatch(FETCH_ACCOUNTING_HISTORICAL_INVOICES);
      }
    },
    async selectTabAndLoadData() {
      if (this.isValidUser) {
        const selectedTab = this.previousAccountingTab < 0 ? 0 : this.previousAccountingTab;
        const tabObj = document.getElementById('manageaccounting_tabs');
        tabObj.ej2_instances[0].enableTab(selectedTab, true);
        tabObj.ej2_instances[0].select(selectedTab);
        await this.$store.dispatch(FETCH_ACCOUNTING_OPEN_INVOICES);
        // await this.$store.dispatch(FETCH_ACCOUNTING_CLOSED_INVOICES);
        // await this.$store.dispatch(FETCH_ACCOUNTING_HISTORICAL_INVOICES);
        // await this.$store.dispatch(FETCH_ACCOUNTING_USER_CREDITS);
        // await this.$store.dispatch(FETCH_ACCOUNTING_TRANSACTION_REFUNDS);
      }
    },
    onAddInvoiceClick(e) {
      const id = e?.item?.properties?.id;
      // eslint-disable-next-line default-case
      switch (id) {
        case 'AdditionalInvoice':
          this.$router.push(`/accounting/additional-invoice`);
          break;
        case 'MiscellaneousInvoice':
          this.$router.push(`/accounting/miscellaneous-invoice`);
          break;
      }
    },
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import '../../../assets/styles/eservices-base.css';

.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
.e-btn-icon.e-export-pdf.e-icons {
  color: red;
}
.e-btn-icon.e-excelexport.e-icons.e-icon-left {
  color: green;
}
</style>
